export default __webpack_public_path__ + "src/fonts/AvenirLTStd-Light.otf";